<app-top>
  <h1>Pyramiderna</h1>
  <h2>Råd för bättre juverhälsa</h2>
</app-top>

<nav class="box">
  <ng-container *ngFor="let pyramid of pyramids">
    <a [routerLink]="['/', pyramid.path]" appLinkButton [color]="pyramid.color" icon="pyramid">
      {{ pyramid.title }}
    </a>
  </ng-container>
</nav>
